var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShopyfox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 129,
    viewBox: "0 0 123 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.452 59.1506L44.8301 24.1506C42.4387 22.7699 39.3807 23.5892 38 25.9808L5.5 82.2724C4.11925 84.6639 4.93866 87.7218 7.33013 89.1025L67.9519 124.103C70.3434 125.483 73.4013 124.664 74.782 122.272L107.282 65.9808C108.663 63.5892 107.843 60.5314 105.452 59.1506Z",
    fill: "url(#paint0_linear_30_69)",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9858 41.5609L63.7358 26.4054C68.5683 18.0353 79.2711 15.1675 87.6413 20C96.0114 24.8325 98.8792 35.5353 94.0467 43.9054L85.2967 59.0609",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_69",
    x1: 42.553,
    y1: 32.8769,
    x2: 56.3218,
    y2: 119.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C24E06"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShopyfox);
export default __webpack_public_path__ + "static/media/ic_shopyfox.c93710a5c84e453b2b0c57c494271872.svg";
export { ForwardRef as ReactComponent };